<template>
  <div class="cell small-12 medium-12">
    <div class="grid-x">
      <div v-for="(item, index) in 4" :key="item" class="cell large-3 medium-3 small-6 padding-right-s" :class="{ 'margin-bottom-xs': index === 0 }">
        <Skeleton height="150px" />
      </div>
    </div>
  </div>
</template>

<script setup>
import Skeleton from '@nuxt-common/atomic-ui/app/components/skeleton/Skeleton.vue';
</script>
